"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFormatUnit = void 0;
function defaultFormatUnit(unit, unitSystem) {
    var positive = [];
    var negative = [];
    unitSystem.getDimensions().forEach(function (dimension) {
        var exponent = unit[dimension];
        if (exponent < 0) {
            negative.push([unitSystem.getSymbol(dimension), unit[dimension]]);
        }
        else if (exponent > 0) {
            positive.push([unitSystem.getSymbol(dimension), unit[dimension]]);
        }
    });
    if (positive.length === 0 && negative.length === 0) {
        return "";
    }
    positive.sort(orderDimensions);
    negative.sort(orderDimensions);
    if (positive.length === 0) {
        return formatDimensions(negative);
    }
    var numerator = formatDimensions(positive);
    if (negative.length === 0) {
        return numerator;
    }
    var denominator = formatDimensions(negative.map(negateDimension));
    return "".concat(numerator, " / ").concat(maybeParenthesize(denominator, negative.length !== 1));
}
exports.defaultFormatUnit = defaultFormatUnit;
function orderDimensions(_a, _b) {
    var leftSymbol = _a[0];
    var rightSymbol = _b[0];
    return leftSymbol < rightSymbol ? -1 : 1;
}
function formatDimensions(dimensions) {
    return dimensions
        .map(function (_a) {
        var symbol = _a[0], exponent = _a[1];
        var exponentStr = exponent !== 1 ? "^".concat(exponent) : "";
        return "".concat(symbol).concat(exponentStr);
    })
        .join(" * ");
}
function negateDimension(_a) {
    var symbol = _a[0], exponent = _a[1];
    return [symbol, -exponent];
}
function maybeParenthesize(text, parenthesize) {
    return parenthesize ? "(".concat(text, ")") : text;
}
//# sourceMappingURL=format.js.map